'use client';

import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { usePopover } from '../../../hooks/use-popover';

import type { Item } from './types';
import { isPdf } from './file-storage-utils';
import { SetS3Config } from '../../../awsClientConfig';
import { Storage } from 'aws-amplify';

const tagOptions = ['Personal', 'Work', 'Business', 'Accounting', 'Security', 'Design'] satisfies string[];

export interface ItemModalProps {
  item: Item;
  onClose?: () => void;
  onDelete?: (itemId: string) => void;
  onFavorite?: (itemId: string, value: boolean) => void;
  open?: boolean;
}

export function ItemModal({ item, onClose, onDelete, onFavorite, open = false }: ItemModalProps): React.JSX.Element {
  const tagsPopover = usePopover<HTMLButtonElement>();
  const [pdfForm, setPdfForm] = React.useState<string>();

  React.useEffect(() => {
    if(isPdf(item?.S3Key)){
      fetchPdfForm(item);
    }
  },[item]);

  const fetchPdfForm = async (item:Item) => {
    try {
      SetS3Config(`documents-${process.env.REACT_APP_MODE}-optima-financial-group`, "public");
      const irsForm = await Storage.get(item.S3Key, {
        customPrefix: { public: "" },
        level: "public",
        contentType: "application/pdf",
      });
      setPdfForm(irsForm);
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        maxWidth="sm"
        onClose={onClose}
        open={open}
        sx={{
          '& .MuiDialog-container': { justifyContent: 'flex-end' },
          '& .MuiDialog-paper': { height: '100%', width: '100%' },
        }}
      >
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, p: 0 }}>
        <div
              style={{
                width: '100%',
                height: '100%',
                objectFit: "cover",
                borderWidth: 2,
                borderColor: "#ddd",
                borderStyle: "solid",
                textAlign: "center",
                marginLeft: 10,
                marginTop: '2rem'
              }}
            >
              {isPdf(item?.S3Key) ? (
                <iframe
                  src={pdfForm}
                  title="app-logo"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: "cover",
                    borderWidth: 2,
                    borderColor: "#ddd",
                  }}
                />
              ) : (
                <img
                  src={item?.S3Bucket}
                  alt="app-logo"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: "cover",
                    borderWidth: 2,
                    borderColor: "#ddd",
                  }}
                />
              )}
            </div>
        </DialogContent>
      </Dialog>
      <Menu
        anchorEl={tagsPopover.anchorRef.current}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        onClose={tagsPopover.handleClose}
        open={tagsPopover.open}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        {tagOptions.map((option) => (
          <MenuItem key={option}>{option}</MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
}
